
$(function()
{
    const isMobile = window.matchMedia("(max-width: 991.98px)").matches;

    if (isMobile)
    {
        const currentCategory = $(".main-navbar-collapsable li[data-category-id=\"" + window.Jah.currentCategoryId + "\"]");

        const currentCategoryParent = (currentCategory.length && currentCategory.hasClass(".ddown")) ? currentCategory : currentCategory.closest(".ddown");

        if (currentCategoryParent.length)
        {
            currentCategoryParent.addClass("open");
            currentCategoryParent.find("> .collapse").slideDown();
        }
    }

    $(".navbar .navbar-toggler").on("click", function(event)
    {
        event.preventDefault();

        const menu = $(".main-navbar-collapsable");

        $(this).toggleClass("open");

        if ($(this).hasClass("open"))
        {
            $("body").addClass("menu-open");
            menu.slideDown();
        }
        else
        {
            $("body").removeClass("menu-open");
            menu.slideUp();
        }

        return false;
    });

    $(".main-navbar-collapsable .expand").on("click", function(event)
    {
        event.preventDefault();
        const parent = $(this).closest("li");
        const mainmenu = parent.closest(".mainmenu");
        const collapse = parent.find("> .collapse");
        const hasOpen = parent.hasClass("open");

        $(".ddown.open .expand").text("+");
        $(".ddown.open").removeClass("open");
        mainmenu.find(".collapse").slideUp();

        if (hasOpen)
        {
            $(this).text("+");
            collapse.slideUp();
        }
        else
        {
            $(this).text("-");
            parent.addClass("open");
            collapse.slideDown();
        }

        return false;
    });
});
